import Vue from 'vue'
import Vuex from 'vuex'
import {CognitoUserSession} from 'amazon-cognito-identity-js';
import {gQuery} from "@/services/graphql";
import {AllSubscriptions, AllSubscriptions_subscriptions} from "../../../shared/generated/AllSubscriptions";
import {SubscriptionsGQL} from "../../../shared/src/queries/SubscriptionsGQL";
import {SubscriptionStatus} from "../../../shared/generated/globalTypes";

Vue.use(Vuex)

interface RootState {
    userSession?: CognitoUserSession
    showLeftMenu: boolean
    subscriptions: AllSubscriptions_subscriptions[]
    errorMessage?: string
}

export default new Vuex.Store<RootState>({
    state: {
        userSession: undefined,
        showLeftMenu: false,
        subscriptions: [],
        errorMessage: undefined
    },
    getters: {
        getUserEmail(state): string {
            return state.userSession?.getIdToken().decodePayload().email || ''
        },
        hasActiveSubscriptions(state): boolean {
            return !!state.subscriptions.find(_ => _.status === SubscriptionStatus.ACTIVE)
        },
        showErrorMessage(state): boolean {
            return !!state.errorMessage
        }
    },
    mutations: {
        setUserSession(state, userSession: CognitoUserSession) {
            state.userSession = userSession
        },
        setShowLeftMenu(state, showLeftMenu: boolean) {
            state.showLeftMenu = showLeftMenu
        },
        setSubscriptions(state, subscriptions: AllSubscriptions_subscriptions[]) {
            state.subscriptions = subscriptions
        },
        setErrorMessage(state, msg?: string) {
            state.errorMessage = msg
        }
    },
    actions: {
        setUserSession({commit}, userSession: CognitoUserSession) {
            commit('setUserSession', userSession)
        },
        showLeftMenu({commit}) {
            commit('setShowLeftMenu', true)
        },
        hideLeftMenu({commit}) {
            commit('setShowLeftMenu', false)
        },
        async loadSubscriptions({commit}) {
            const result = await gQuery<AllSubscriptions>(SubscriptionsGQL.ALL_SUBSCRIPTIONS);
            commit('setSubscriptions', result.data.subscriptions.sort((a, b) => b.createDate.localeCompare(a.createDate)))
        }
        // ,
        // async loadTableDescription({commit}, payload: {profile: string, tableName: string}) {
        //     const result = await gQuery<DescribeTable, DescribeTableVariables>(TablesGQL.DESCRIBE_TABLE, {
        //         profileId: payload.profile,
        //         tableName: payload.tableName
        //     })
        //
        //     console.log('sss', result.data.describeTable)
        // }
    },
    modules: {}
})
